// extracted by mini-css-extract-plugin
export default {"container":"sjR5Qcr3CCkkP0YOTVmi","colorPaletteContainer":"M5qUu_MserYXAJfs3xEQ","icon":"wAHrPLHBKS9xmvgG4rah"};